import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../core/config/app.config';
import { IEventNotificationModel } from './event-notification.model';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class EventNotificationsService {
  private http = inject(HttpClient);
  private config = inject(AppConfig);

  private readonly baseUrl: string;

  constructor() {
    this.baseUrl = `${this.config.buildUri('eventNotifications')}/`;
  }

  getEventNotifications(): Observable<IEventNotificationModel[]> {
    const url = `${this.baseUrl}EventNotifications/`;
    return this.http.get<IEventNotificationModel[]>(url);
  }

  getEventNotificationsByEventId(eventId: number): Observable<IEventNotificationModel[]> {
    const url = `${this.baseUrl}GetEventNotificationsByEvent/?eventId=${eventId}`;
    return this.http.get<IEventNotificationModel[]>(url);
  }

  create(notification: IEventNotificationModel): Observable<IEventNotificationModel> {
    const url = `${this.baseUrl}EventNotifications/`;
    return this.http.post<IEventNotificationModel>(url, notification);
  }

  delete(notificationId: number): Observable<any> {
    const url = `${this.baseUrl}EventNotifications?eventId=${notificationId}`;
    return this.http.delete(url);
  }

  update(notification: IEventNotificationModel): Observable<IEventNotificationModel> {
    const url = `${this.baseUrl}EventNotifications/`;
    return this.http.put<IEventNotificationModel>(url, notification);
  }
}
